import React, { InputHTMLAttributes } from 'react';
import classnames from 'classnames';

import styles from './Checkbox.module.scss';

export interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
}

const Checkbox: React.FC<CheckboxProps> = (props) => {
  const { label, name, className, ...otherProps } = props;
  const rootClassName = classnames(styles.root, className);

  return (
    <div className={rootClassName}>
      <label>
        <input className='visually-hidden' type='radio' {...otherProps} />
        <span className={styles.label}>{label}</span>
      </label>
    </div>
  );
};

export default Checkbox;
